export function createPalette() {
  return {
    // divider: '#F2F4F7',
  };
}
